import Flex from '@Components/Bases/Flex';
import { CloudDownloadOutlined } from '@mui/icons-material';
import { Link, Typography, useTheme } from '@mui/material';
import React from 'react';

type FileInputHelperProps = {
  url: string;
  errorMessage?: string;
  helperText?: string;
};

const FileInputHelper: React.FC<FileInputHelperProps> = (props) => {
  const { url, errorMessage, helperText } = props;
  const theme = useTheme();

  const handleDownload = async () => {
    if (url) {
      const link = document.createElement('a');
      link.href = url;
      const fileName = url.substring(url.lastIndexOf('/') + 1);
      link.setAttribute('download', fileName);

      link.download = url.split('/').pop() || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Link
        onClick={handleDownload}
        style={{
          cursor: 'pointer',
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <CloudDownloadOutlined
          fontSize="inherit"
          style={{
            verticalAlign: 'middle',
            marginRight: '0.125rem',
            color: theme.palette.info.light,
          }}
        />
        <Typography variant="caption" color="info.light">
          ดาวน์โหลดไฟล์
        </Typography>
      </Link>
      {errorMessage || helperText}
    </Flex>
  );
};

export default FileInputHelper;
